import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { Grid, GridCol } from '@naf/grid';
import { Text, TextVariant } from '@naf/text';
import styled from 'styled-components';
import { spacing, breakpoints, themeLight, borderRadius } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { AnimateText, AnimateStatic } from '@naf/animation';
import { propValidationConfig } from './propValidationConfig';
export let FullScreenHeadingVariant;
(function (FullScreenHeadingVariant) {
  FullScreenHeadingVariant["Display"] = "display";
  FullScreenHeadingVariant["Giga"] = "giga";
})(FullScreenHeadingVariant || (FullScreenHeadingVariant = {}));
export const FullScreenHeader = /*#__PURE__*/forwardRef(({
  navbar,
  title,
  subText,
  imageOrVideo,
  nafBranded = true,
  className,
  ctaButton,
  overlay,
  headingVariant = FullScreenHeadingVariant.Giga
}, ref) => {
  const [navBarHeightValue, setNavBarHeightValue] = useState('0');
  const [subTextHeightValue, setSubTextHeightValue] = useState('0');
  const navBarRef = useRef(null);
  const ingressRef = useRef(null);
  useEffect(() => {
    if (navbar && navBarRef && navBarRef.current && typeof window !== 'undefined') {
      const navBarHeight = navBarRef.current.clientHeight;
      if (navBarHeight) setNavBarHeightValue(`${navBarHeight}`);
    }
  }, [navbar]);
  useEffect(() => {
    if (subText && ingressRef && ingressRef.current && typeof window !== 'undefined') {
      const ingressHeight = ingressRef.current.clientHeight;
      if (ingressHeight) setSubTextHeightValue(`${ingressHeight}`);
    }
  }, [subText]);
  const findHeadingVariant = size => {
    switch (size) {
      case 'display':
        return TextVariant.Display;
      case 'giga':
        return TextVariant.Giga;
      default:
        return TextVariant.Giga;
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    ref: ref,
    subTextHeight: subTextHeightValue
  }, /*#__PURE__*/React.createElement("div", {
    ref: navBarRef
  }, navbar || null), /*#__PURE__*/React.createElement(ImageWrapper, null, overlay && /*#__PURE__*/React.createElement(GradientOverlay, null), imageOrVideo && /*#__PURE__*/React.createElement(Image, null, imageOrVideo)), /*#__PURE__*/React.createElement(Header, {
    navBarHeight: navBarHeightValue
  }, /*#__PURE__*/React.createElement(StyledGridCol, {
    s: "12",
    m: "12",
    l: "12",
    xl: "12"
  }, /*#__PURE__*/React.createElement(AnimateText, {
    textProps: {
      variant: findHeadingVariant(headingVariant)
    }
  }, title), nafBranded && /*#__PURE__*/React.createElement(AnimateStatic, {
    delay: 600
  }, /*#__PURE__*/React.createElement(YellowLine, null)), ctaButton || null), subText && /*#__PURE__*/React.createElement(Ingress, {
    ref: ingressRef,
    navBarHeight: navBarHeightValue,
    variant: TextVariant.Ingress
  }, subText)));
});
const Wrapper = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "FullScreenHeader__Wrapper",
  componentId: "sc-so8yqo-0"
})(["position:relative;width:100vw;", " margin-bottom:", ";z-index:5;"], props => props.subTextHeight ? `height: calc(85vh + ${props.subTextHeight}px - 77px);` : 'height: 85vh;', spacing.space48);
const ImageWrapper = styled.div.withConfig({
  displayName: "FullScreenHeader__ImageWrapper",
  componentId: "sc-so8yqo-1"
})(["position:absolute;top:0;height:85vh;width:100vw;z-index:-50;"]);
const GradientOverlay = styled.div.withConfig({
  displayName: "FullScreenHeader__GradientOverlay",
  componentId: "sc-so8yqo-2"
})(["position:absolute;top:0;left:0;right:0;height:85vh;background:linear-gradient(0deg,rgba(0,0,0,0.1),rgba(0,0,0,0.1)),linear-gradient(180deg,rgba(0,0,0,0.8) 0%,rgba(0,0,0,0) 50%);"]);
const Header = styled(Grid).withConfig({
  displayName: "FullScreenHeader__Header",
  componentId: "sc-so8yqo-3"
})(["", " grid-gap:", " !important;max-width:1120px;margin:auto;padding:0 ", ";position:relative;@media (max-width:", "){padding:0 ", ";}"], props => props.navBarHeight ? `height: calc(85vh - ${props.navBarHeight}px);` : 'height: 85vh;', spacing.space24, spacing.space48, breakpoints.s, spacing.space24);
const StyledGridCol = styled(GridCol).withConfig({
  displayName: "FullScreenHeader__StyledGridCol",
  componentId: "sc-so8yqo-4"
})(["color:", ";"], ({
  theme
}) => theme.typography ? theme.typography.brandTextInverted : themeLight.typography.brandTextInverted);
const Ingress = styled(Text).withConfig({
  displayName: "FullScreenHeader__Ingress",
  componentId: "sc-so8yqo-5"
})(["grid-column:1 / 8;background-color:white;border-radius:", ";padding:", " ", ";height:fit-content;align-self:flex-end;position:absolute;", " left:-", ";@media (max-width:", "){grid-column:1 / -1;}@media (max-width:", "){padding:", ";margin:0 -", " -91px -", ";left:0;", "}"], borderRadius.M, spacing.space24, spacing.space32, props => props.navBarHeight ? `top: calc(85vh - ${props.navBarHeight}px - 77px);` : 'top: calc(85vh - 77px);', spacing.space32, breakpoints.l, breakpoints.s, spacing.space16, spacing.space16, spacing.space16, props => props.navBarHeight ? `top: calc(85vh - ${props.navBarHeight}px - 39px);` : 'top: calc(85vh - 39px);');
const YellowLine = styled.div.withConfig({
  displayName: "FullScreenHeader__YellowLine",
  componentId: "sc-so8yqo-6"
})(["background-color:", ";width:126px;height:4px;margin-top:", ";"], nafColor.signature.yellow, spacing.space24);
const Image = styled.div.withConfig({
  displayName: "FullScreenHeader__Image",
  componentId: "sc-so8yqo-7"
})(["& > img,& > video{width:100%;height:85vh;object-fit:cover;z-index:1;display:block;}"]);
//# sourceMappingURL=FullScreenHeader.js.map